import ToastCustom from 'src/javascripts/components/alerts/ToastCustom';


export default function() {

  $('.copy-url').click(function() {
    $('[data-toggle="tooltip"]').tooltip('hide');

    /* Get the text field */
    let selector = $(this).attr('data-selector');

    // Create temp field and copy value
    // Needed because we can't copy from a hidden field
    let $temp = $("<textarea></textarea>");
    $("body").append($temp);

    // Select value
    let valToCopy = $(selector).val();
    $temp.val(valToCopy).select();

    // Copy and remove temp field
    document.execCommand("copy");
    $temp.remove();

    // Indicate success
    ToastCustom({title: 'URL copied', message: "Copied the link to your clipboard", delay: 4000});

  })

}